import React from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "../../components/sidebar";
import Pages from "../../../shared/routes/Pages";

import classes from "./AdminLayout.module.css";

const AdminLayout = () => {
  return (
    <div className={classes["content-wrapper"]}>
      <Sidebar locationName={useLocation().pathname} />
      <div className={classes["page-wrapper"]}>
        <Pages />
      </div>
    </div>
  );
};

export default AdminLayout;
